module.exports = __webpack_public_path__ + "img/01买车.614e9179.jpg";